
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControlDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StaticDictionaryItem } from 'src/app/shared/model/StaticDictionaryItem';
import { StaticDictionaryService } from 'src/app/shared/services/static-dictionary.service';
import { ControlSettings } from '../../ControlSettings';


@Component({
  selector: 'static-dictionary-select-ctrl',
  templateUrl: './static-dictionary-select.component.html',
  styleUrls: ['./static-dictionary-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: StaticDictionarySelectComponent,
    multi: true
  }]
})
export class StaticDictionarySelectComponent implements ControlValueAccessor,OnInit  {

  constructor(protected controlContainer: ControlContainer, private staticDictionary: StaticDictionaryService) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {fxFill:false, readonly: false};
  @Input() staticDictionaryName: string;
  @Input() textField  = 'value';
  @Input() valueField  = 'id';
  @Input() allowedValuesLimitation : number[];
  @Input() allowedValueCheck: (item: number) => boolean;
  @Input() disallowedValues : number[];
  @Input() orderById : boolean;
  
  @Output() valueChangeEvent = new EventEmitter<number>();
 
  valueList$: Observable<StaticDictionaryItem[]>;

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

    this.valueList$ = this.staticDictionary.getStaticDictionary(this.staticDictionaryName);

    if(this.allowedValueCheck){
      this.valueList$ = this.valueList$.pipe(map(x => x.filter(r => this.allowedValueCheck(r.id))) );
    }

    if(this.allowedValuesLimitation){
      this.valueList$ = this.valueList$.pipe(map(x => x.filter(r => this.allowedValuesLimitation.includes(r.id))) );
    }

    if(this.disallowedValues){
      this.valueList$ = this.valueList$.pipe(map(x => x.filter(r => !this.disallowedValues.includes(r.id))) );
    }
   
    if(this.orderById){
      this.valueList$ = this.valueList$.pipe(map(x => x.sort(this.orderDictionaryItemsById)) );
    }


    if (this.settings.showEmptyValue) {
      const emptyItem = { id: undefined, value: '', key: undefined } as StaticDictionaryItem;
      this.valueList$ = this.valueList$.pipe(map(x => [emptyItem, ...x]));
    }

    if(this.settings.uppercase){
       this.valueList$ = this.valueList$.pipe(map(x => {
        x.forEach(y => y.value = y.value.toUpperCase()); 
        return x;
      }) );
    }
  }

  orderDictionaryItemsById(a:StaticDictionaryItem,b:StaticDictionaryItem): number {
     return a.id - b.id;
  }

  onChange(value: number) {
   
    // this.control.setValue(value);
    this.valueChangeEvent.emit(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }

}


